export default "__VITE_ASSET__BAkrWX0B__"